var info = {
  title: 'CounterSketch | Join our Live Session Webinar',
  video: 'https://gemvision.com/sharedMedia/cs_landing_video_with_music.mp4',
  poster: 'https://meteor.stullercloud.com/das/116998426',
  background: 'https://meteor.stullercloud.com/das/116998422',
  host: 'https://meteor.stullercloud.com/das/116998429',
  hostDescription: 'Beau Vallot, Central Territory sales rep.',
  logo: 'https://gemvision.com/Images/CounterSketch/CounterSketch-Primary-Logo-2-Color.svg',
  description1:
    'Register to attend a 60-minute CounterSketch webinar to learn how our software can help you build a customer-centric business. As a special thank you for your participation and to help you get started, we’re offering a 5% discount on the purchase of your first license.',
  description2:
    'CounterSketch is a simplified 3D jewelry design software that helps you enhance the customer’s experience at the point of sale by customizing jewelry alongside your customers, providing real-time pricing, and manufacturing your designs with just a few simple clicks.',
  buttonColor: '#3f6cb4',
  titleBackgroundColor: '#252525'
}

export default info
